<ion-toast
	[isOpen]="toastService.showsToast$ | async"
	[message]="toastService.toastMessage$ | async"
	[duration]="5000"
	(didDismiss)="dismiss()"
	[color]="toastService.toastState$ | async"
	[buttons]="toastService.toastButtons$ | async"
	swipeGesture="vertical"
	position="top"></ion-toast>
